import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const BedHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.5 21.622v-7c4.432-1.981 14.568-1.981 19 0v7M2.5 18.5h19M5.557 12.1a1.92 1.92 0 0 1 .23-1.9 14.6 14.6 0 0 1 4.72 0c.271.378.407.836.385 1.3m7.551.6a1.92 1.92 0 0 0-.23-1.9 14.6 14.6 0 0 0-4.72 0 2.06 2.06 0 0 0-.385 1.3m7.392 1.122v-5a14.7 14.7 0 0 0-3.5-.894m-10 0c-1.2.153-2.375.453-3.5.894v5M13.822 2.5A1.97 1.97 0 0 0 12 3.725 1.98 1.98 0 0 0 10.175 2.5 2.157 2.157 0 0 0 8.2 4.677C8.2 7.061 11.494 9 12 9s3.8-1.939 3.8-4.323A2.157 2.157 0 0 0 13.822 2.5"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(BedHeart) as SvgIcon;
export { ForwardRef as ReactComponent };
